










import { defineComponent } from '@vue/composition-api';

import useDeliveryAreaCode from '@/useDeliveryAreaCode';

const WorkingLogsDisplay = defineComponent({
  props: {
    distanceArray: { type: Array, required: true },
  },
  setup() {
    const { distanceTypeToColor } = useDeliveryAreaCode();
    return {
      distanceTypeToColor,
    };
  },
});

export default WorkingLogsDisplay;
